import { colors } from 'theme'

export const defaultThemeStyles = {
    progressOver: colors.grey,
    progressPath: colors.blackLight,
    progressTrail: colors.grey,
}
